export default "__VITE_ASSET__DwLWWQdK__"